<template>
  <div>
    <p>
      {{ $t('camera', {browserName}) }}
    </p>
    <p>
      {{ $t('check', {browserName}) }}
    </p>
    <ol>
      <li>
        {{ $t('p1_menu') }} <mdicon name="apple" /> {{ $t('p1_pref') }}
      </li>
      <li>
        {{ $t('p2', {browserName}) }}
      </li>
      <li>
        {{ $t('p3', {browserName}) }}
      </li>
      <li>
        {{ $t('p4', {browserName}) }}
      </li>
    </ol>
    <br>
    <p>
      {{ $t('more') }} <a target="_blank" href="https://support.apple.com/guide/mac-help/mchlf6d108da">{{ $t('support') }}</a>.
    </p>
  </div>
</template>

<script>
import { mdiApple } from '@mdi/js';

export default {
  name: 'BlockedAtSystemLevelMacOs',
  props: {
    browserName: {
      type: String,
      required: true,
    },
  },
  methods: {
    check() {
      this.$emit('check');
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
camera: Your camera is not connected or {browserName} access to the camera is denied at the operating-system level.
check: Check if the camera works in other applications (like Photo Booth). If everything works, make sure {browserName} can access the camera.
p1_menu: Select the Apple menu
p1_pref: → "System Preferences", click "Security & Privacy", then click "Privacy";
p2: Select Camera and check the box next to the {browserName} app;
p3: Select Microphone and check the box next to the {browserName} application;
p4: Restart {browserName} and try the interview again.
more: Learn more on the
support: Apple Support site
</i18n>

<i18n locale="ru" lang="yaml">
camera: Камера не подключена, либо доступ {browserName} к камере запрещён на уровне операционной системы.
check: Проверьте, работает ли камера в других приложениях (например, Photo Booth). Если с камерой всё в порядке, убедитесь, что {browserName} имеет доступ к камере.
p1_menu: Выберите меню Apple
p1_pref: → «Системные настройки», нажмите «Защита и безопасность», затем нажмите «Конфиденциальность»;
p2: Выберите «Камера», установите флажок рядом с приложением {browserName};
p3: Выберите «Микрофон», установите флажок рядом с приложением {browserName};
p4: Перезапустите {browserName} и попробуйте пройти интервью ещё раз.
more: Подробнее на сайте
support: поддержки Apple
</i18n>
